import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Registrar Service Worker para cache offline de mídias
if ('serviceWorker' in navigator) {
    window.addEventListener('load', async () => {
        try {
            // IMPORTANTE: Primeiro, forçar atualização de qualquer SW antigo
            const existingRegistrations = await navigator.serviceWorker.getRegistrations();
            for (const registration of existingRegistrations) {
                // Forçar atualização
                await registration.update();
                console.log('[Main] 🔄 Service Worker atualizado');
            }

            const registration = await navigator.serviceWorker.register('/sw.js', {
                scope: '/',
                updateViaCache: 'none' // Força sempre buscar nova versão
            });
            console.log('[Main] ✅ Service Worker registrado:', registration.scope);

            // Se há uma nova versão esperando, ativar imediatamente
            if (registration.waiting) {
                registration.waiting.postMessage({ type: 'SKIP_WAITING' });
            }

            // Listener para quando uma nova versão ficar disponível
            registration.addEventListener('updatefound', () => {
                const newWorker = registration.installing;
                if (newWorker) {
                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            console.log('[Main] 🔄 Nova versão do Service Worker disponível');
                            newWorker.postMessage({ type: 'SKIP_WAITING' });
                        }
                    });
                }
            });

            // Solicitar armazenamento persistente
            if ('storage' in navigator && 'persist' in navigator.storage) {
                const isPersisted = await navigator.storage.persist();
                console.log(`[Main] 💾 Armazenamento persistente: ${isPersisted ? 'Ativado' : 'Não concedido'}`);
            }
        } catch (error) {
            console.warn('[Main] ⚠️ Erro ao registrar Service Worker:', error);
        }
    });
}

createRoot(document.getElementById("root")!).render(<App />);

